<template xmlns="http://www.w3.org/1999/html">
  <div class="page-wrapper" style="padding-top: 0">
    <div class="item" v-for="(item,index) in trafficList" :key="'keyA'+index">
      <div class="flex">
        <span class="bold">{{item}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AmbitusInfo",
    props: {
      trafficList: {
        type: Array,
        default: null
      }
    },
    watch: {
    },
    data() {
      return {
      }

    },
    computed: {
    },
    methods: {
      showImg(src) {
        this.$emit('showimg', src)
      }
    },
    created() {
    }
  }
</script>

<style scoped>
  .item {
    display: inline-block;
    /*margin-right: 30px;*/
    line-height: 1;
    margin-bottom: 25px;
    width: 100%;
    box-sizing: border-box;
    vertical-align: top;
    margin-right: 10px;
    min-width: 150px;
    /*min-width: 100px;*/

  }

  .file-img {
    width: 200px;
    height: 130px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }

  .vt {
    vertical-align: top;
  }

  h3 {
    margin: 10px 0 25px 0;
    font-size: 12px;
  }

  .m10 {
    margin: 10px 0 0 0;
  }

  .inlineblock {
    display: inline-block;
    /*margin-right: 20px;*/
    vertical-align: top;
  }

  .bold {
    font-weight: bold;
    min-width: 50px;
    display: inline-block;
  }
  .flex{
    display: flex;
  }


</style>
